import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BookingConfirmationModal = ({ isOpen, onClose, bookingData, bookingId }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-card border border-border rounded-lg shadow-lg max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6 space-y-6">
          {/* Success Header */}
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground mb-2">Pickup Scheduled Successfully!</h2>
              <p className="text-sm text-muted-foreground">
                Your laundry pickup has been confirmed. We'll be there on time!
              </p>
            </div>
          </div>

          {/* Booking Details */}
          <div className="bg-muted rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
              <span className="font-medium text-foreground">Booking ID:</span>
              <span className="font-mono text-primary font-semibold">{bookingId}</span>
            </div>

            <div className="border-t border-border pt-3 space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Customer:</span>
                <span className="text-foreground font-medium">{bookingData?.name}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Mobile:</span>
                <span className="text-foreground">{bookingData?.mobile}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Pickup Date:</span>
                <span className="text-foreground font-medium">{bookingData?.date}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Time Slot:</span>
                <span className="text-foreground">{bookingData?.timeSlot}</span>
              </div>
            </div>
          </div>

          {/* Next Steps */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">What happens next?</h3>

            <div className="space-y-3">
              {/* <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary">1</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">SMS Confirmation</p>
                  <p className="text-xs text-muted-foreground">You'll receive an SMS with pickup details shortly</p>
                </div>
              </div> */}

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary">1</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">Pickup Reminder</p>
                  <p className="text-xs text-muted-foreground">We'll call 30 minutes before arrival</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-bold text-primary">2</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">Quality Service</p>
                  <p className="text-xs text-muted-foreground">Professional cleaning and timely delivery</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <Icon name="Phone" size={20} className="text-accent mt-0.5" />
              <div>
                <h4 className="font-medium text-accent mb-1">Need Help?</h4>
                <p className="text-sm text-muted-foreground mb-2">
                  Contact us for any changes or queries
                </p>
                <div className="space-y-1">
                  <p className="text-sm font-medium text-foreground">📞 +91 96000 44004</p>
                  <p className="text-sm font-medium text-foreground">📧 support@maayolaundry.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* <Button
              variant="outline"
              fullWidth
              onClick={() => window.print()}
              iconName="Download"
              iconPosition="left"
            >
              Save Details
            </Button> */}
            <Button
              variant="default"
              fullWidth
              onClick={onClose}
              className="bg-primary hover:bg-primary/90"
            >
              Done
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmationModal;
